// extracted by mini-css-extract-plugin
export default {"text":"TruncatedText_text__5Ktw-","tooltip":"TruncatedText_tooltip__gBMHP"};